function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import TopBarDesktopComponent from "./desktop/top-bar-desktop-component";
import TopBarMobileComponent from "./mobile/top-bar-mobile-component";
import { StyledTopBarNewComponent } from "./top-bar-component.scss";
class TopBarNewComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(StyledTopBarNewComponent, {
            className: "top-bar-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "top-bar-desktop-wrapper",
                    children: /*#__PURE__*/ _jsx(TopBarDesktopComponent, _object_spread({}, this.props))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "top-bar-mobile-wrapper",
                    children: /*#__PURE__*/ _jsx(TopBarMobileComponent, _object_spread({}, this.props))
                })
            ]
        });
    }
}
export { TopBarNewComponent as default };
